import { StepContentReferenceType } from "@sdbn/appclient";

export const TERMINAL_WIZARD_DEFINITION = {
  identifier: 'registration-terminal-wizard-configuration',
  defaultWizardFlowStepIdentifier: 'registration-terminal-wizard-configuration',
  wizardFlowMetadata: [
    {
      flowIdentifier: 'registration-terminal-transport-registration',
      flowDefinition: {
        title: 'Transport Anmelden',
        key: 'registration-terminal-transport-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.language-selection.title',
            key: 'language-selection',
            controller: 'language-selection-controller',
            contentIdentifier: 'dashboard-language-selection'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'registration-type-selection',
            controller: 'process-selection-controller',
            contentIdentifier: 'processSelectionWidget',
            stepContentReferenceType: StepContentReferenceType.simpleDashboard,
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.primary',
                  titleIconCss: 'fa-thin fa-barcode',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.primary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'transport-registration-with-code'
                },
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.secondary',
                  titleIconCss: 'fa-thin fa-plus',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.secondary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'vehicle-type-selection'
                }
              ]
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.title',
            key: 'transport-registration-with-code',
            controller: 'transport-registration-with-code-controller',
            contentIdentifier: 'dashboard-transport-registration-with-code',
            dashboardConfiguration: {
              nextProcessStepQrCodeScanned: 'transport-registration-masterdata',
              nextProcessStepRegistrationCode: 'transport-registration-masterdata'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'vehicle-type-selection',
            controller: 'dictionary-lookup-selection-controller',
            contentIdentifier: 'tileSelectionWidget',
            stepContentReferenceType: StepContentReferenceType.simpleDashboard,
            dashboardConfiguration: {
              dictionaryKey: 'tmc-yard.common.enum.vehicle-type',
              targetField: 'vehicleType',
              restrictOptions: ['truck','light-van']
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-masterdata.title',
            key: 'transport-registration-masterdata',
            controller: 'transport-registration-masterdata-controller',
            contentIdentifier: 'dashboard-transport-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-options.title',
            key: 'transport-registration-options',
            controller: 'transport-registration-options-controller',
            contentIdentifier: 'dashboard-transport-registration-options'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.title',
            key: 'transport-registration-smartphone-connection',
            controller: 'transport-registration-smartphone-connection-controller',
            contentIdentifier: 'dashboard-transport-registration-smartphone-connection',
            dashboardConfiguration: {
              availableOptions: ['messaging-hint','global-connect', 'sms'],
              showPhoneNumberInputForGlobalConnect: false,
              hidePhoneNumberInput: false,
              showPhoneNumberDialog: true,
              showHints: false
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-instructions.title',
            key: 'instruction-test',
            controller: 'instruction-test-controller',
            contentIdentifier: 'WIDGET@instructionTestWidget',
            dashboardConfiguration: {
              instructionConfigurationUrls: ['/assets/customer/kardex/transport-instruction.json']
            }
          },
          {
            title: null,
            key: 'transport-registration-send-data-to-backend',
            controller: 'transport-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
            key: 'transport-registration-summary',
            controller: 'transport-registration-summary-controller',
            contentIdentifier: 'dashboard-transport-registration-summary'
          }
        ]
      }
    },
    {
      flowIdentifier: 'registration-terminal-truck-registration',
      flowDefinition: {
        title: 'LKW Anmelden',
        key: 'registration-terminal-truck-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.truck-registration-masterdata.title',
            key: 'truck-registration-masterdata',
            controller: 'truck-registration-masterdata-controller',
            contentIdentifier: 'dashboard-truck-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-smartphone-connection.title',
            key: 'truck-registration-smartphone-connection',
            controller: 'truck-registration-smartphone-connection-controller',
            contentIdentifier: 'dashboard-transport-registration-smartphone-connection'
          },
          {
            title: null,
            key: 'truck-registration-send-data-to-backend',
            controller: 'truck-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
            key: 'truck-registration-summary',
            controller: 'truck-registration-summary-controller',
            contentIdentifier: 'dashboard-truck-registration-summary'
          }
        ]
      }
    },
        {
      flowIdentifier: 'registration-terminal-visitor-registration',
      flowDefinition: {
        title: 'Besucher Anmelden',
        key: 'registration-terminal-visitor-registration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'registration-type-selection',
            controller: 'process-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.primary',
                  titleIconCss: 'fa-thin fa-qrcode',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.primary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitor-registration-with-code'
                },
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.secondary',
                  titleIconCss: 'fa-thin fa-plus',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.secondary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitortype-selection'
                }
              ]
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-role-selection.title',
            key: 'visitortype-selection',
            controller: 'visitor-visitortype-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              roleDefaultProcessStep: {
                default: 'visitor-registration-masterdata'
              }
            }
          },
          /* {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.title',
            key: 'visitor-registration-with-code',
            controller: 'visitor-registration-with-barcode-controller',
            contentIdentifier: 'dashboard-transport-registration-with-code',
            dashboardConfiguration: {
              qrCodeScannerWebWidget: 'WIDGET@visitorScanRegistrationQRCodeWidget'
            }
          }, */
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.title',
            key: 'visitor-registration-with-code',
            controller: 'visitor-registration-with-code-qrcode-combined-controller',
            contentIdentifier: 'WIDGET@registrationWithCodeQRCodeCombinedWidget',
            dashboardConfiguration: {
              showCreateNewRegistrationButton: false,
              registrationCodeMinLength: 9,
              nextProcessStepRegistrationCode: 'visitor-registration-masterdata',
              qrCodeScanEnabled: true,
              allowUnknownOnlineTerminalRegistrationCodes: true,
              barcodeMapping: {
                'tmc-visit://visitor': 'visitor-registration-masterdata',
                'tmc-visit://registration': 'visitor-registration-with-onlinebarcode',
              }
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.barcode-scan.title',
            key: 'visitor-registration-with-onlinebarcode',
            controller: 'visitor-registration-with-onlinebarcode-controller',
            contentIdentifier: 'dashboard-terminal-registration-code-validation'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-masterdata.title',
            key: 'visitor-registration-masterdata',
            controller: 'visitor-registration-masterdata-controller',
            contentIdentifier: 'dashboard-visitor-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-instructions.title',
            key: 'instruction-test',
            controller: 'instruction-test-controller',
            contentIdentifier: 'WIDGET@instructionTestWidget',
            dashboardConfiguration: {
              instructionConfigurationUrls: ['/assets/default/instruction.json']
            }
          },
          {
            title: null,
            key: 'visitor-registration-send-data-to-backend',
            controller: 'visitor-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.title',
            key: 'visitor-registration-summary',
            controller: 'visitor-registration-summary-controller',
            contentIdentifier: 'dashboard-visitor-registration-summary'
          }
        ]
      }
    },
    {
      flowIdentifier: 'registration-terminal-visitor-leave',
      flowDefinition: {
        title: 'Besucher abmelden',
        key: 'registration-terminal-visitor-leave',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-confirmation.title',
            key: 'visitor-leave-confirmation',
            controller: 'process-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.visitor-leave-confirmation.confirm-leave',
                  titleIconCss: 'fa-thin fa-arrow-right-from-bracket',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitor-leave-send-data-to-backend'
                }
              ]
            }
          },
          {
            title: null,
            key: 'visitor-leave-send-data-to-backend',
            controller: 'visitor-leave-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-summary.title',
            key: 'visitor-leave-summary',
            controller: 'visitor-leave-summary-controller',
            contentIdentifier: 'dashboard-visitor-leave-summary'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-failed.title',
            key: 'visitor-leave-failed',
            controller: 'visitor-leave-failed-controller',
            contentIdentifier: 'dashboard-visitor-leave-failed'
          }
        ]
      }
    },
    {
      flowIdentifier: 'registration-terminal-wizard-configuration',
      flowDefinition: {
        title: 'Anmeldeterminal',
        key: 'registration-terminal-wizard-configuration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: null,
            key: 'load-terminal-configuration',
            controller: 'terminal-configuration-controller',
            contentIdentifier: null,
            dashboardConfiguration: {
              terminalIdentifier: 'default'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.language-selection.title',
            key: 'language-selection',
            controller: 'language-selection-controller',
            contentIdentifier: 'dashboard-language-selection'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'registration-type-selection',
            controller: 'process-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.register-transport',
                  titleIconCss: 'fa-thin fa-truck-container',
                  actionType: 'PROCESS_FLOW',
                  processFlowKey: 'registration-terminal-transport-registration'
                },
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.registration-process-selection.step.register-visitor',
                  titleIconCss: 'fa-thin fa-people',
                  actionType: 'PROCESS_FLOW',
                  processFlowKey: 'registration-terminal-visitor-registration'
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
